"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSdk = exports.PairsByLPTokenDocument = exports.PairsByTokensABDocument = exports.getBuiltGraphSDK = exports.subscribe = exports.execute = exports.getBuiltGraphClient = exports.createBuiltMeshHTTPHandler = exports.getMeshOptions = exports.rawServeConfig = void 0;
const utils_1 = require("@graphql-mesh/utils");
const utils_2 = require("@graphql-mesh/utils");
const utils_3 = require("@graphql-mesh/utils");
const cache_localforage_1 = __importDefault(require("@graphql-mesh/cache-localforage"));
const fetch_1 = require("@whatwg-node/fetch");
const graphql_1 = __importDefault(require("@graphql-mesh/graphql"));
const merger_stitching_1 = __importDefault(require("@graphql-mesh/merger-stitching"));
const utils_4 = require("@graphql-mesh/utils");
const http_1 = require("@graphql-mesh/http");
const runtime_1 = require("@graphql-mesh/runtime");
const store_1 = require("@graphql-mesh/store");
const cross_helpers_1 = require("@graphql-mesh/cross-helpers");
const importedModule$0 = __importStar(require("./sources/quickswap-v2-polygon/introspectionSchema"));
const importedModule$1 = __importStar(require("./sources/sushiswap-v2-arbitrum/introspectionSchema"));
const importedModule$2 = __importStar(require("./sources/sushiswap-v2-ethereum/introspectionSchema"));
const importedModule$3 = __importStar(require("./sources/uniswap-v2-ethereum/introspectionSchema"));
const importedModule$4 = __importStar(require("./sources/sushiswap-v2-bsc/introspectionSchema"));
const importedModule$5 = __importStar(require("./sources/sushiswap-v2-polygon/introspectionSchema"));
const importedModule$6 = __importStar(require("./sources/pancakeswap-v2-bsc/introspectionSchema"));
const baseDir = cross_helpers_1.path.join(typeof __dirname === 'string' ? __dirname : '/', '..');
const importFn = (moduleId) => {
    const relativeModuleId = (cross_helpers_1.path.isAbsolute(moduleId) ? cross_helpers_1.path.relative(baseDir, moduleId) : moduleId).split('\\').join('/').replace(baseDir + '/', '');
    switch (relativeModuleId) {
        case ".graphclient/sources/quickswap-v2-polygon/introspectionSchema":
            return Promise.resolve(importedModule$0);
        case ".graphclient/sources/sushiswap-v2-arbitrum/introspectionSchema":
            return Promise.resolve(importedModule$1);
        case ".graphclient/sources/sushiswap-v2-ethereum/introspectionSchema":
            return Promise.resolve(importedModule$2);
        case ".graphclient/sources/uniswap-v2-ethereum/introspectionSchema":
            return Promise.resolve(importedModule$3);
        case ".graphclient/sources/sushiswap-v2-bsc/introspectionSchema":
            return Promise.resolve(importedModule$4);
        case ".graphclient/sources/sushiswap-v2-polygon/introspectionSchema":
            return Promise.resolve(importedModule$5);
        case ".graphclient/sources/pancakeswap-v2-bsc/introspectionSchema":
            return Promise.resolve(importedModule$6);
        default:
            return Promise.reject(new Error(`Cannot find module '${relativeModuleId}'.`));
    }
};
const rootStore = new store_1.MeshStore('.graphclient', new store_1.FsStoreStorageAdapter({
    cwd: baseDir,
    importFn,
    fileType: "ts",
}), {
    readonly: true,
    validate: false
});
exports.rawServeConfig = undefined;
async function getMeshOptions() {
    const pubsub = new utils_2.PubSub();
    const sourcesStore = rootStore.child('sources');
    const logger = new utils_3.DefaultLogger("GraphClient");
    const cache = new cache_localforage_1.default({
        ...{},
        importFn,
        store: rootStore.child('cache'),
        pubsub,
        logger,
    });
    const sources = [];
    const transforms = [];
    const additionalEnvelopPlugins = [];
    const uniswapV2EthereumTransforms = [];
    const sushiswapV2EthereumTransforms = [];
    const sushiswapV2PolygonTransforms = [];
    const sushiswapV2BscTransforms = [];
    const sushiswapV2ArbitrumTransforms = [];
    const pancakeswapV2BscTransforms = [];
    const quickswapV2PolygonTransforms = [];
    const additionalTypeDefs = [];
    const uniswapV2EthereumHandler = new graphql_1.default({
        name: "uniswap-v2-ethereum",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/ianlapham/uniswap-v2-dev" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("uniswap-v2-ethereum"),
        logger: logger.child("uniswap-v2-ethereum"),
        importFn,
    });
    const sushiswapV2EthereumHandler = new graphql_1.default({
        name: "sushiswap-v2-ethereum",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/sushiswap/exchange" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("sushiswap-v2-ethereum"),
        logger: logger.child("sushiswap-v2-ethereum"),
        importFn,
    });
    const sushiswapV2PolygonHandler = new graphql_1.default({
        name: "sushiswap-v2-polygon",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/sushiswap/matic-exchange" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("sushiswap-v2-polygon"),
        logger: logger.child("sushiswap-v2-polygon"),
        importFn,
    });
    const sushiswapV2BscHandler = new graphql_1.default({
        name: "sushiswap-v2-bsc",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/sushiswap/bsc-exchange" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("sushiswap-v2-bsc"),
        logger: logger.child("sushiswap-v2-bsc"),
        importFn,
    });
    const sushiswapV2ArbitrumHandler = new graphql_1.default({
        name: "sushiswap-v2-arbitrum",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/sushiswap/arbitrum-exchange" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("sushiswap-v2-arbitrum"),
        logger: logger.child("sushiswap-v2-arbitrum"),
        importFn,
    });
    const pancakeswapV2BscHandler = new graphql_1.default({
        name: "pancakeswap-v2-bsc",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/ord786/pancakeswap" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("pancakeswap-v2-bsc"),
        logger: logger.child("pancakeswap-v2-bsc"),
        importFn,
    });
    const quickswapV2PolygonHandler = new graphql_1.default({
        name: "quickswap-v2-polygon",
        config: { "endpoint": "https://api.thegraph.com/subgraphs/name/shivannguyen/quickswap-matic2" },
        baseDir,
        cache,
        pubsub,
        store: sourcesStore.child("quickswap-v2-polygon"),
        logger: logger.child("quickswap-v2-polygon"),
        importFn,
    });
    sources[0] = {
        name: 'uniswap-v2-ethereum',
        handler: uniswapV2EthereumHandler,
        transforms: uniswapV2EthereumTransforms
    };
    sources[1] = {
        name: 'sushiswap-v2-ethereum',
        handler: sushiswapV2EthereumHandler,
        transforms: sushiswapV2EthereumTransforms
    };
    sources[2] = {
        name: 'sushiswap-v2-polygon',
        handler: sushiswapV2PolygonHandler,
        transforms: sushiswapV2PolygonTransforms
    };
    sources[3] = {
        name: 'sushiswap-v2-bsc',
        handler: sushiswapV2BscHandler,
        transforms: sushiswapV2BscTransforms
    };
    sources[4] = {
        name: 'sushiswap-v2-arbitrum',
        handler: sushiswapV2ArbitrumHandler,
        transforms: sushiswapV2ArbitrumTransforms
    };
    sources[5] = {
        name: 'pancakeswap-v2-bsc',
        handler: pancakeswapV2BscHandler,
        transforms: pancakeswapV2BscTransforms
    };
    sources[6] = {
        name: 'quickswap-v2-polygon',
        handler: quickswapV2PolygonHandler,
        transforms: quickswapV2PolygonTransforms
    };
    const additionalResolvers = [];
    const merger = new merger_stitching_1.default({
        cache,
        pubsub,
        logger: logger.child('stitchingMerger'),
        store: rootStore.child('stitchingMerger')
    });
    return {
        sources,
        transforms,
        additionalTypeDefs,
        additionalResolvers,
        cache,
        pubsub,
        merger,
        logger,
        additionalEnvelopPlugins,
        get documents() {
            return [
                {
                    document: PairsByTokensAbDocument,
                    get rawSDL() {
                        return (0, utils_4.printWithCache)(PairsByTokensAbDocument);
                    },
                    location: 'PairsByTokensAbDocument.graphql'
                }, {
                    document: PairsByLpTokenDocument,
                    get rawSDL() {
                        return (0, utils_4.printWithCache)(PairsByLpTokenDocument);
                    },
                    location: 'PairsByLpTokenDocument.graphql'
                }
            ];
        },
        fetchFn: fetch_1.fetch,
    };
}
exports.getMeshOptions = getMeshOptions;
function createBuiltMeshHTTPHandler() {
    return (0, http_1.createMeshHTTPHandler)({
        baseDir,
        getBuiltMesh: getBuiltGraphClient,
        rawServeConfig: undefined,
    });
}
exports.createBuiltMeshHTTPHandler = createBuiltMeshHTTPHandler;
let meshInstance$;
function getBuiltGraphClient() {
    if (meshInstance$ == null) {
        meshInstance$ = getMeshOptions().then(meshOptions => (0, runtime_1.getMesh)(meshOptions)).then(mesh => {
            const id = mesh.pubsub.subscribe('destroy', () => {
                meshInstance$ = undefined;
                mesh.pubsub.unsubscribe(id);
            });
            return mesh;
        });
    }
    return meshInstance$;
}
exports.getBuiltGraphClient = getBuiltGraphClient;
const execute = (...args) => getBuiltGraphClient().then(({ execute }) => execute(...args));
exports.execute = execute;
const subscribe = (...args) => getBuiltGraphClient().then(({ subscribe }) => subscribe(...args));
exports.subscribe = subscribe;
function getBuiltGraphSDK(globalContext) {
    const sdkRequester$ = getBuiltGraphClient().then(({ sdkRequesterFactory }) => sdkRequesterFactory(globalContext));
    return getSdk((...args) => sdkRequester$.then(sdkRequester => sdkRequester(...args)));
}
exports.getBuiltGraphSDK = getBuiltGraphSDK;
exports.PairsByTokensABDocument = (0, utils_1.gql) `
    query PairsByTokensAB($tokens: [String!]) {
  pairs(where: {token0_in: $tokens, token1_in: $tokens}) {
    id
    reserve0
    reserve1
    token0 {
      id
      symbol
      decimals
    }
    token1 {
      id
      symbol
      decimals
    }
  }
}
    `;
exports.PairsByLPTokenDocument = (0, utils_1.gql) `
    query PairsByLPToken($tokens: [ID!]) {
  pairs(where: {id_in: $tokens}) {
    id
    reserve0
    reserve1
    token0 {
      id
      symbol
      decimals
    }
    token1 {
      id
      symbol
      decimals
    }
  }
}
    `;
function getSdk(requester) {
    return {
        PairsByTokensAB(variables, options) {
            return requester(exports.PairsByTokensABDocument, variables, options);
        },
        PairsByLPToken(variables, options) {
            return requester(exports.PairsByLPTokenDocument, variables, options);
        }
    };
}
exports.getSdk = getSdk;
